import ApplicationContract from "./ApplicationContract";

const index = () => {
  return <ApplicationContract />;
};

export default index;
